import { useWalletWithdrawalMinimumAmountQuery } from '../data-access/queries/useWalletWithdrawalMinimumAmountQuery';

/**
 * @params 	currencyType
 * @returns min amount to withdraw that currency type
 */
export const useWalletWithdrawalMinimumAmount = (currencyType: string) => {
	const { data: minAmount, error, isLoading } = useWalletWithdrawalMinimumAmountQuery({ currencyType });

	return {
		error,
		isLoading,
		minAmount
	};
};
